// Runtime configuration that can be set at deployment time
declare global {
  interface Window {
    ENV?: {
      REACT_APP_AUTH_URI?: string;
      REACT_APP_PARTNER_PORTAL_API_URL?: string;
      REACT_APP_AUTH_CLIENT_ID?: string;
      REACT_APP_DOCUMENT_VIEWER_URL?: string;
      REACT_APP_BUILD_VERSION?: string;
      NODE_ENV?: string;
      REACT_APP_HOTJAR_SITE_ID?: string;
      REACT_APP_APPINSIGHTS_CONNECTION_STRING?: string;
    };
  }
}

// Helper to check if a value is a placeholder (should be ignored)
const isPlaceholder = (value: string | undefined): boolean => {
  return !value || value.startsWith("PLACEHOLDER_");
};

// Helper to get runtime value, ignoring placeholders
const getRuntimeValue = (windowEnvValue: string | undefined, envValue: string | undefined): string | undefined => {
  if (!isPlaceholder(windowEnvValue)) {
    return windowEnvValue;
  }
  return envValue;
};

export const getRuntimeConfig = () => {
  return {
    authUri: getRuntimeValue(window.ENV?.REACT_APP_AUTH_URI, import.meta.env.VITE_AUTH_URI),
    apiUrl:
      getRuntimeValue(window.ENV?.REACT_APP_PARTNER_PORTAL_API_URL, import.meta.env.VITE_PARTNER_PORTAL_API_URL) ||
      "https://partner-int.campaustralia.com.au/",
    clientId: getRuntimeValue(window.ENV?.REACT_APP_AUTH_CLIENT_ID, import.meta.env.VITE_AUTH_CLIENT_ID),
    documentViewerUrl: getRuntimeValue(
      window.ENV?.REACT_APP_DOCUMENT_VIEWER_URL,
      import.meta.env.VITE_DOCUMENT_VIEWER_URL,
    ),
    buildVersion: getRuntimeValue(window.ENV?.REACT_APP_BUILD_VERSION, import.meta.env.VITE_BUILD_VERSION),
    nodeEnv: getRuntimeValue(window.ENV?.NODE_ENV, import.meta.env.MODE) || "development",
    hotjarSiteId: getRuntimeValue(window.ENV?.REACT_APP_HOTJAR_SITE_ID, import.meta.env.VITE_HOTJAR_SITE_ID) || "",
    applicationInsightsConnectionString: getRuntimeValue(
      window.ENV?.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
      import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
    ),
  };
};
